import { Box, Typography } from "@mui/material";

const healthColors: Record<string, string> = {
  ok: "#4caf50",
  degraded: "#ff9800",
  unreachable: "#ef5350",
};

interface Props {
  health: string;
}

export const IntegrationHealthBadge = ({ health }: Props) => {
  const color = healthColors[health] ?? "#ff9800";

  return (
    <Box sx={{ gap: 0.5, alignItems: "center", display: "flex" }}>
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          backgroundColor: color,
          flexShrink: 0,
        }}
      />
      {/* caption to match the metadata text it sits beside (e.g. the
          relative time on the overview card) — body2 next to caption
          reads as a vertical misalignment */}
      <Typography variant="caption" color="text.secondary">
        {health === "ok" ? "ok" : health}
      </Typography>
    </Box>
  );
};
